{
  "CANNED_MGMT": {
    "HEADER": "Respostes predeterminades",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Afegir resposta predeterminada",
    "LOADING": "S'estan recollint les respostes predeterminades...",
    "SEARCH_404": "No hi ha cap resposta que coincideixi amb aquesta consulta.",
    "LIST": {
      "404": "No hi ha respostes predeterminades disponibles en aquest compte.",
      "TITLE": "Gestiona les respostes predeterminades",
      "DESC": "Les respostes predeterminades són plantilles de resposta predefinides que es poden utilitzar per enviar ràpidament respostes a les converses.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Codi curt",
        "CONTENT": "Contingut",
        "INBOXES": "Safates d'entrada",
        "ACTIONS": "Accions"
      },
      "ALL_INBOXES": "Totes les safates d'entrada",
      "FILTER": {
        "ALL_INBOXES": "Totes les safates d'entrada",
        "NO_INBOX": "Sense safata d'entrada",
        "SEARCH_PLACEHOLDER": "Cerca safates d'entrada"
      }
    },
    "ADD": {
      "TITLE": "Afegir resposta predeterminada",
      "DESC": "Les respostes predeterminades són plantilles de resposta predefinides que es poden utilitzar per enviar ràpidament respostes a les converses.",
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Codi curt",
          "PLACEHOLDER": "Introduïu un codi curt.",
          "ERROR": "És necessari el codi curt."
        },
        "SUBJECT": {
          "LABEL": "Assumpte (només correu)",
          "PLACEHOLDER": "Assumpte opcional per a respostes per correu / noves converses"
        },
        "CONTENT": {
          "LABEL": "Missatge",
          "PLACEHOLDER": "Escriviu el missatge que voleu desar com a plantilla per utilitzar-lo més tard.",
          "ERROR": "El missatge és obligatori."
        },
        "ATTACHMENTS": {
          "LABEL": "Adjunts"
        },
        "INBOXES": {
          "LABEL": "Safates d'entrada",
          "PLACEHOLDER": "Selecciona safates d'entrada (opcional, deixa-ho buit per a totes)"
        },
        "SUBMIT": "Envia"
      },
      "API": {
        "SUCCESS_MESSAGE": "Resposta predeterminada afegida correctament.",
        "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
      }
    },
    "EDIT": {
      "TITLE": "Edita la resposta predeterminada",
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Codi curt",
          "PLACEHOLDER": "Introduïu un codi curt.",
          "ERROR": "És necessari el codi curt."
        },
        "SUBJECT": {
          "LABEL": "Assumpte (només correu)",
          "PLACEHOLDER": "Assumpte opcional per a respostes per correu / noves converses"
        },
        "CONTENT": {
          "LABEL": "Missatge",
          "PLACEHOLDER": "Escriviu el missatge que voleu desar com a plantilla per utilitzar-lo més tard.",
          "ERROR": "El missatge és obligatori."
        },
        "ATTACHMENTS": {
          "LABEL": "Adjunts"
        },
        "INBOXES": {
          "LABEL": "Safates d'entrada",
          "PLACEHOLDER": "Selecciona safates d'entrada (opcional, deixa-ho buit per a totes)"
        },
        "SUBMIT": "Envia"
      },
      "BUTTON_TEXT": "Edita",
      "API": {
        "SUCCESS_MESSAGE": "Resposta predeterminada actualitzada correctament.",
        "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Esborra",
      "API": {
        "SUCCESS_MESSAGE": "Resposta predeterminada eliminada correctament.",
        "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
      },
      "CONFIRM": {
        "TITLE": "Confirma l'esborrat",
        "MESSAGE": "N'estas segur ",
        "YES": "Sí, esborra ",
        "NO": "No, mantén-la "
      }
    }
  }
}
